import React, { Component, ChangeEvent } from 'react'
import { inject, observer } from 'mobx-react'

import { RouteProps } from 'react-router'
import { WithTranslation, withTranslation } from 'react-i18next'

import {
    Button,
    FormControl,
    InputLabel,
    FormHelperText,
    OutlinedInput
} from '@material-ui/core'

import AuthStore from '../../../../stores/auth.store'

import { SignInUser } from './../../../../models/User.model'

import './../auth.style.scss'

interface SignInProps extends RouteProps, WithTranslation {
    authStore?: AuthStore
}

@inject((stores) => ({
    authStore: (stores as any).authStore as AuthStore,
}))
@observer
class SignInComponent extends Component<SignInProps, any> {

    componentWillMount = () => {
    }

    componentWillUnmount = () => {
        this.props.authStore!.clearSignInObject()
    }

    onChange = (prop: 'email' | 'password' | 'name', event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target
        this.props.authStore!.updateSignInData(prop, value)
    }

    render() {
        const { t, authStore } = this.props
        const { name, email, password, isPasswordValid, isUserValid, isEmailValid } = authStore!.signInObject

        return (
            <form className={'signin-form'} noValidate autoComplete="on" >
                <FormControl variant="outlined" fullWidth className={'input'} required error={!isEmailValid}>
                    <InputLabel htmlFor="name-input">{t('name')}</InputLabel>
                    <OutlinedInput
                        id="name-input"
                        value={name}
                        onChange={this.onChange.bind(this, 'name')}
                        type='string'
                        label={t('name')}
                    />
                </FormControl>
                <FormControl variant="outlined" fullWidth className={'input'} required error={!isEmailValid}>
                    <InputLabel htmlFor="email-input">{t('email')}</InputLabel>
                    <OutlinedInput
                        id="email-input"
                        value={email}
                        onChange={this.onChange.bind(this, 'email')}
                        type='email'
                        label={t('email')}
                    />
                    {!isEmailValid && <FormHelperText id="email-input-error-text">Error</FormHelperText>}
                </FormControl>
                <FormControl variant="outlined" fullWidth error={!isPasswordValid} className={'input'} required>
                    <InputLabel htmlFor="password-input">{t('password')}</InputLabel>
                    <OutlinedInput
                        id="password-input"
                        value={password}
                        onChange={this.onChange.bind(this, 'password')}
                        type='password'
                        label={t('password')}
                        aria-describedby="component-error-text"
                    />
                    {!isPasswordValid && <FormHelperText id="component-error-text">Error</FormHelperText>}
                </FormControl>

                <Button fullWidth disabled={!isUserValid} onClick={authStore!.signIn}>{t('signin')}</Button>
            </form>)
    }
}

export default withTranslation('authScreen')(SignInComponent)
